import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PinterestIcon from '@mui/icons-material/Pinterest';
import TelegramIcon from '@mui/icons-material/Telegram';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';

const TikTokIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props}>
    <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.6 2.6 0 0 1-2.59-2.6 2.6 2.6 0 0 1 3.4-2.47V9.67a5.73 5.73 0 0 0-.81-.06A5.7 5.7 0 0 0 4.17 15.3 5.7 5.7 0 0 0 9.86 21a5.7 5.7 0 0 0 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.25-1.48Z" />
  </SvgIcon>
);

export type SocialNetworkKey =
  | 'instagramUrl'
  | 'facebookUrl'
  | 'tiktokUrl'
  | 'youtubeUrl'
  | 'xUrl'
  | 'linkedinUrl'
  | 'pinterestUrl'
  | 'telegramUrl';

export interface SocialNetworkOption {
  key: SocialNetworkKey;
  label: string;
  placeholder: string;
  icon: React.ComponentType<SvgIconProps>;
}

export const SOCIAL_NETWORKS: SocialNetworkOption[] = [
  { key: 'instagramUrl', label: 'Instagram', placeholder: 'https://instagram.com/tutienda', icon: InstagramIcon },
  { key: 'facebookUrl', label: 'Facebook', placeholder: 'https://facebook.com/tutienda', icon: FacebookIcon },
  { key: 'tiktokUrl', label: 'TikTok', placeholder: 'https://tiktok.com/@tutienda', icon: TikTokIcon },
  { key: 'youtubeUrl', label: 'YouTube', placeholder: 'https://youtube.com/@tutienda', icon: YouTubeIcon },
  { key: 'xUrl', label: 'X (Twitter)', placeholder: 'https://x.com/tutienda', icon: XIcon },
  { key: 'linkedinUrl', label: 'LinkedIn', placeholder: 'https://linkedin.com/company/tutienda', icon: LinkedInIcon },
  { key: 'pinterestUrl', label: 'Pinterest', placeholder: 'https://pinterest.com/tutienda', icon: PinterestIcon },
  { key: 'telegramUrl', label: 'Telegram', placeholder: 'https://t.me/tutienda', icon: TelegramIcon },
];
